import React from "react";
import { useRef } from "react";
import { toast } from "react-toastify";
const ReportChart = (props) => {
  const data = props["data"];
  const xAxeRef = useRef(null);
  const yAxeRef = useRef(null);
  const chartTypeRef = useRef(null);
  const yTypeRef = useRef(null);

  const saveAndValidateHandler = (event) => {
    event.preventDefault();
    if (
      xAxeRef.current?.value === ("" || "default") ||
      yAxeRef.current?.value === ("" || "default") ||
      chartTypeRef?.current.value === ("" || "default") ||
      yTypeRef.current?.value === ("" || "default")
    ) {
      toast.error("لطفا تمامی مقادیر را واردکنید");
    } else {
      let chartData = {
        chartType: chartTypeRef.current.value,
        xAxeValue: xAxeRef.current?.value,
        yAxeValue: yAxeRef.current?.value,
        yoperator: yTypeRef.current?.value,
      };
      props.onSaveReportChartData(chartData);
      xAxeRef.current.value = "default";
      yAxeRef.current.value = "default";
      chartTypeRef.current.value = "default";
      yTypeRef.current.value = "default";
    }
  };
  return (
    <>
      <div className="selectBox">
        <div className="selectBox-sides">
          <label htmlFor="id1" className="control-lable form-label labelMargin">
            ستون X
          </label>
          <select
            className="inputBox"
            id="id1"
            defaultValue={"default"}
            ref={xAxeRef}
            required
            name="xAxeValue"
          >
            <option value={"default"}>گزینه مورد نظر خود را انتخاب کنید</option>
            {data["x"]?.map((v) => (
              <option value={v.key} key={v.key}>
                {v.name}
              </option>
            ))}
          </select>
        </div>

        <div className="selectBox-sides">
          <label htmlFor="id2" className="control-lable form-label labelMargin">
            ستون Y
          </label>
          <select
            className="inputBox"
            id="id2"
            defaultValue={"default"}
            required
            ref={yAxeRef}
            name="yAxeValue"
          >
            <option value={"default"}>گزینه مورد نظر خود را انتخاب کنید</option>
            {data["y"]?.map((v) => (
              <option key={v.key} value={v.key}>
                {v.name}{" "}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="selectBox">
        <div className="selectBox-sides">
          <label htmlFor="id2" className="control-lable form-label labelMargin">
            واکشی ستون Y{" "}
          </label>
          <select
            className="inputBox"
            id="id2"
            defaultValue={"default"}
            name="yoperator"
            required
            ref={yTypeRef}
          >
            <option value={"default"}>گزینه مورد نظر خود را انتخاب کنید</option>
            <option value="MAX">بیشترین</option>
            <option value="MIN">کمترین</option>
            <option value="SUM">مجموع</option>
            <option value="AVG">میانگین</option>
            <option value="">تعداد</option>
          </select>
        </div>
      </div>
      <div className="selectBox">
        <div className="selectBox-sides">
          <label htmlFor="id3" className="control-lable form-label labelMargin">
            نوع نمودار
          </label>
          <select
            className="inputBox"
            id="id3"
            defaultValue={"default"}
            ref={chartTypeRef}
            required
            name="chartType"
          >
            <option value={"default"}>گزینه مورد نظر خود را انتخاب کنید</option>
            <option value="circle">دایره ای</option>
            <option value="bar">بار</option>
            <option value="line">خطی</option>
          </select>
        </div>
      </div>
      <div className="button-box mb-4">
        <button
          type="submit"
          onClick={saveAndValidateHandler}
          className="mx-auto mt-5"
        >
          تایید
        </button>
      </div>
    </>
  );
};
export default React.memo(ReportChart);
